export enum StatusPagamentoLink {
  SALVA = 0,
  PENDENTE = 1,
  PAGA = 2,
  REEMBOLSADA = 3
}

export interface SavedRide {
  id: string;
  nomePassageiro: string;
  celularCliente: string;
  enderecoOrigem: string;
  enderecoDestino: string;
  dataAgendamentoCorrida: string;
  valorCorrida: number;
  valorTotal?: number;
  stripePaymentLinkUrl?: string;
  statusPagamentoLink: StatusPagamentoLink;
  pagamentoLinkId?: string;
}

export interface PagamentoLink {
  id: string;
  vendedorId: string;
  nomeCliente: string;
  celularCliente: string;
  corridaIds: string[];
  valorTotal: number;
  status: StatusPagamentoLink;
  stripePaymentLinkUrl: string;
  dataCriacao: string;
  dataPagamento?: string;
  dataReembolso?: string;
}

export interface GerarLinkResponse {
  url: string;
  valorTotal: number;
  pagamentoLinkId: string;
}
